import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

// Header Authorization inyectado a nivel de modulo, UNA sola vez. Antes se
// registraba en un useEffect de useAuth() (AuthProvider), pero React corre los
// effects de los hijos ANTES que los del padre, asi que los primeros requests
// de los descendientes salian sin header y recibian 401. Lee localStorage en
// cada llamada. Guard contra doble registro (HMR / StrictMode).
if (api.__authRequestInterceptorId === undefined) {
	api.__authRequestInterceptorId = api.interceptors.request.use(
		(config) => {
			try {
				const token = localStorage.getItem("token");
				if (token) {
					config.headers["Authorization"] = `Bearer ${JSON.parse(token)}`;
				}
			} catch (e) {}
			return config;
		},
		(error) => Promise.reject(error)
	);
}

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

// Inject ENV_TOKEN automatically on all openApi requests
openApi.interceptors.request.use((config) => {
	const token = process.env.REACT_APP_ENV_TOKEN;
	if (token) {
		config.params = { ...config.params, token };
	}
	return config;
});

export default api;
